import { defineStore } from "pinia";
import { ref } from "vue";

export const useMessageStore = defineStore("message", () => {
  const text = ref<string | null>(null);
  const type = ref<"success" | "error" | null>(null);

  let timeoutId: number | null = null;

  const showMessage = (message: string, messageType: "success" | "error" = "success", duration: number = 3000) => {
    text.value = message;
    type.value = messageType;

    // 이전 타이머가 있다면 초기화
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    // 일정 시간 후 메시지 자동 삭제
    timeoutId = window.setTimeout(() => {
      clearMessage();
    }, duration);
  };

  const clearMessage = () => {
    text.value = null;
    type.value = null;
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  return { text, type, showMessage, clearMessage };
});
